import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import AddressesRepository from 'src/features/addresses/data/AddressesRepository';
import { AddressesRepositoryInterface } from 'src/features/addresses/domain/AddressesRepositoryInterface';
import { diContainer } from 'src/inversify.config';

const addressesRepository =
  diContainer.get<AddressesRepositoryInterface>(AddressesRepository);

export default function useStoreSlug() {
  const { user, session } = useAuthContext();

  const userStoreSlug = useMemo(
    () => user?.main_address?.store_data?.slug_name,
    [user]
  );
  const storeSlug = useMemo(
    () => userStoreSlug || 'revolucion',
    [userStoreSlug]
  );

  const query = useQuery({
    queryKey: ['storeAvailability', userStoreSlug],
    queryFn: () =>
      addressesRepository.checkStoreAvailability({
        storeSlug: userStoreSlug as string,
        accessToken: session?.accessToken as string,
      }),
    enabled: !!userStoreSlug && !!session?.accessToken,
  });

  return {
    storeSlug,
    userStoreSlug,
    isAvailable: query.isLoading ? true : query.data?.isAvailable,
    nextOpen: query.data?.nextOpen,
    nextClose: query.data?.nextClose,
    ...query,
  };
}
